<template>
  <div class="component-content">
    <!-- <el-button type="danger" class="vacation-btn">请假/休假/调休申请</el-button> -->
    <router-link to="/m/Personnel/Vacation/Apply" class="vacation-btn">我要请假 (休假/调休)</router-link>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="type">
        <el-radio-button label="0">进行中</el-radio-button>
        <el-radio-button label="1">已审批(已取消、已拒绝)</el-radio-button>
      </el-radio-group>
    </div>
    <div class="list-title">
      <section style="margin-top:5px;">
        <label class="label-name">请假类别：</label>
        <el-select size="small" clearable v-model="filter.type" placeholder="请选择请假类别">
          <el-option v-for="item in typeArr" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </section>
    </div>

    <div class="ball-loading" v-if="loading">
      <div class="k-ball-holder3">
        <div class="k-ball7a"></div>
        <div class="k-ball7b"></div>
        <div class="k-ball7c"></div>
        <div class="k-ball7d"></div>
      </div>
    </div>
    <div class="card-room" v-else>
      <div class="no-list" v-if="paginationData.length<1">
        <p>暂无与你相关的请假信息</p>
      </div>
      <div class="card-item" v-else v-for="item, i in paginationData">
        <div class="title">
          <div class="r">{{item.leaveDays}}天</div>
          <h3 class="name">{{item.type}}</h3>
        </div>
        <div class="info">
          <p>请假原因：{{item.content}}</p>
          <p>请假开始时间：{{item.startTime}}</p>
          <p>请假结束时间：{{item.endTime}}</p>
          <p>审批状态：{{item.flow.status}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import UserInfo from "@/components/UserInfo";
export default {
  components: {
    UserInfo
  },
  computed: {
    ...mapState({
      organization: state => state.main.organization,
      userData: state => state.main.userData
    })
  },
  data() {
    return {
      // 0:待审批 1：已审批
      type: 0,

      //  filter
      typeArr: ["公出", "调休", "病假", "事假", "年休假", "其他"],
      filter: {
        type: "",
        startTime: "",
        endTime: "",
        name: ""
      },

      // 列表
      loading: true,
      pageSize: 2000,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: []
    };
  },
  mounted() {
    this.getLists();

    // 我的会议消息清除
    // this.msgRead();
  },
  methods: {
    // 我的会议消息清除
    // msgRead() {
    //   ajax.get('/msg/conference/read', "", (res) => {})
    // },

    // getUserList(users) {
    //   let _item = ""
    //   for (var i = 0; i < users.length; i++) {
    //     _item += '<span class="user-item">' + users[i].name + '</span>'
    //   }
    //   return _item
    // },

    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPaginationData();
    },
    // 搜索筛选数据
    getFilterData() {
      let _time;
      if (this.filter.time) {
        _time = new Date(this.filter.time).getTime();
      }

      // 筛选出所有符合的数据
      this.filterData = [];
      for (let i = 0; i < this.listData.length; i++) {
        let _item = this.listData[i];

        // 类型
        let _type = false;
        if (!this.filter.type || _item.type == this.filter.type) {
          _type = true;
        }

        // 时间
        let _t_time = false;
        if (!this.filter.startTime) {
          if (!this.filter.endTime) {
            // 两个时间都没有
            _t_time = true;
          } else {
            // 有结束时间
            if (
              _item.startTime < this.filter.endTime ||
              _item.startTime == this.filter.endTime
            ) {
              _t_time = true;
            }
          }
        } else {
          // 判断符合开始时间的
          if (
            _item.startTime > this.filter.startTime ||
            _item.startTime == this.filter.startTime
          ) {
            // 没有结束时间
            if (!this.filter.endTime) {
              _t_time = true;
            } else {
              // 有结束时间
              if (
                _item.startTime < this.filter.endTime ||
                _item.startTime == this.filter.endTime
              ) {
                _t_time = true;
              }
            }
          }
        }

        // 姓名
        let _name = false;
        if (!this.filter.name) {
          _name = true;
        } else {
          console.log(_item.creator.name.toLowerCase());
          if (
            _item.creator.name.toLowerCase().indexOf(this.filter.name) != -1
          ) {
            _name = true;
          }
        }

        if (_type && _t_time && _name) {
          this.filterData.push(_item);
        }
      }

      this.currentPage = 1;
      this.getPaginationData();
    },
    // 分页筛选数据
    getPaginationData() {
      if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
        this.currentPage = Math.ceil(this.filterData.length / this.pageSize);
      }
      if (this.currentPage == 0) {
        this.currentPage = 1;
      }
      // 分页筛选
      this.paginationData = this.filterData.slice(
        this.pageSize * (this.currentPage - 1),
        this.pageSize * this.currentPage
      );
    },
    // 获取列表
    getLists() {
      ajax.get(
        "/human/my/leave/apply/list",
        {
          type: this.type
        },
        res => {
          this.loading = false;
          this.filterData = this.listData = res.vo.array;
          this.getPaginationData();
        }
      );
    }
  },
  watch: {
    type() {
      this.filter.type = "";
      this.getLists();
    },
    filter: {
      handler(n, o) {
        this.getFilterData();
      },
      immediate: true, //刷新加载 立马触发一次handler
      deep: true // 可以深度检测到 person 对象的属性值的变化
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/page/m/vacation/list.vue